<div>
    <v-menu
        v-bind="$attrs"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        location="bottom"
        min-width="0"
        width="auto">
        <template v-slot:activator="{ props }" v-if="allowFieldInput">
            <v-text-field
                v-bind="{ ...$attrs, ...props }"
                v-model="inputDate"
                clearable
                class="date-picker"
                append-inner-icon="mdi-calendar"
                variant="outlined"
                type="date"
                max="9999-12-31"
                hide-details></v-text-field>
        </template>
        <template v-slot:activator="{ props }" v-else>
            <v-text-field
                v-bind="{ ...$attrs, ...props }"
                v-model="displayValue"
                :rules="dateRules"
                append-inner-icon="mdi-calendar"
                readonly
                variant="outlined"
                hide-details></v-text-field>
        </template>
        <v-date-picker
            v-model="value"
            hide-header
            :min="minDateValue"
            :max="maxDateValue"
            @update:modelValue="menu = false"></v-date-picker>
    </v-menu>
</div>